<div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-10">
            <h5 class="headingValue">List of Applications</h5>&nbsp;&nbsp;
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="form-group col-md-3">
            <label>From Date :</label>
            <input type="date" onkeydown="return false" class="form-control" [max]="today1" [(ngModel)]="ptrDashboardSearchCriteria.startDate" (change)="selecetdDate($event.target.value)">
          </div>
          <div class="form-group col-md-3">
            <label>To Date :</label>
            <div>
              <input type="date" onkeydown="return false" class="form-control" [min]="maxDate" [(ngModel)]="ptrDashboardSearchCriteria.endDate">
            </div>
          </div>
          <div class="form-group col-md-3">
            <label> Content :</label>
            <input type="text" class="form-control" placeholder="Enter Content" [(ngModel)]="ptrDashboardSearchCriteria.subject">
          </div>
          <div class="form-group col-md-3" style="padding-top: 3%;">
            <button type="button" class="btn btn-primary acceptBtn" (click)="searchClick()">Search</button> &nbsp; <button type="button" class="btn btn-danger clearBtn" (click)="reset()">Reset</button>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-md-10 headingValue" style="text-align: left;font-size: 18px;">
            <label>Total Records :</label>
            <span style="color: red;"> {{totalPageCount}} </span>
          </div>
          <div class="form-group col-md-2" style="text-align: right;">
            <select class="form-control" [(ngModel)]="ptrDashboardSearchCriteria.rowId" (change)="searchClick()">
              <option [value]="10" selected>10</option>
              <option [value]="25">25</option>
              <option [value]="50">50</option>
              <option [value]="100">100</option>
            </select>
          </div>
        </div>
        <div>
          <div class="row" style="overflow-x:auto;">
            <div class="col-md-12">
              <div class="table-responsive-sm">
                <table class="table table-bordered table-hover">
                  <thead class="thead-light">
                    <tr>
                      <th>S.No.</th>
                      <th sortable="applicationId" (sort)="onSort($event)">Application Id</th>
                      <th sortable="name" (sort)="onSort($event)">Name</th>
                      <th sortable="venueProgram" (sort)="onSort($event)">Venue Program</th>
                      <th sortable="purposeConducting" (sort)="onSort($event)">Purpose of Conducting</th>
                      <th sortable="submittedDate" (sort)="onSort($event)">Applied Date</th>
                      <th sortable="status" (sort)="onSort($event)">Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of allPTRList; let i = index;">
                      <td>{{((ptrDashboardSearchCriteria.pagenumber-1) *ptrDashboardSearchCriteria.rowId)+i+1}}</td>
                      <td>{{item.applicationId !== null ? item.applicationId : '-'}}</td>
                      <td>{{item.name !== null ? item.name : '-'}}</td>
                      <td>{{item.venueProgram !== null ? item.venueProgram : '-'}}</td>
                      <td title="{{item.purposeConducting}}"> {{item.purposeConducting!=null ?
                                          item.purposeConducting.substring(0,25):'-'}}
                        {{item.purposeConducting!=null && item.purposeConducting.length > 25 ? '...' : ''}}
                      </td>
                      <td style="white-space: nowrap;">{{item.submittedDate !== null ? (item.submittedDate | date:'dd-MM-yyyy hh:mm a') : '-'}}</td>
                      <td style="color:#17da37">
                        <span *ngIf="item?.ptrStatusId === 1"> <b>{{item?.ptrStatusName !== null ? item?.ptrStatusName : '-'}}</b> </span>    
                        <span *ngIf="item?.ptrStatusId === 3 || item?.ptrStatusId === 11"> <b>Application Submitted</b> </span>    
                        <span *ngIf="item?.ptrStatusId === 9"> <b>Clarification Pending</b> </span>  
                        <span *ngIf="item?.ptrStatusId === 18"> <b>Application Rejected</b> </span>    
                        <span *ngIf="item?.ptrStatusId === 17"> <b>Certificate Issued</b> </span>      
                        <span *ngIf="item?.ptrStatusId !=1 && item?.ptrStatusId !=3 && item?.ptrStatusId !=9 && item?.ptrStatusId !=11 && item?.ptrStatusId !=18 && item?.ptrStatusId !=17"> <b>Inprogress</b> </span>                                         
                    </td>
                    
                      <td title="Action">
                        <span class=" text-info">
                          <i *ngIf="item?.ptrStatusId != 1" class="fas fa-eye" style="color:#74AEB5" [routerLink]="['../viewPTR/', item?.registrationId]" (click)='encryptionView(item?.registrationId)'></i> &nbsp;
                          <i *ngIf="item?.ptrStatusId === 9 || item?.ptrStatusId === 1" class="fas fa-edit" style="color:#74AEB5" [routerLink]="['../editPTR/', item?.registrationId]" (click)='encryption(item?.registrationId)'></i>
                         </span>
                      </td>
                    </tr>
                    <tr *ngIf="allPTRList===null || allPTRList.length === 0">
                      <td colspan="9" style="text-align: center;padding: 50px !important;">No Data Available in Table</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <br>
          <div class="col-md-12 text-right" *ngIf="allPTRList!==null && allPTRList.length> 0 &&  pageCount>1">
            <ul class="pagination float-right">
              <li class="page-item hoverActive">
                <a class="page-link" [class.my-class]="ptrDashboardSearchCriteria.pagenumber ===1" (click)="first()">
                  <i class="fas fa-angle-double-left"></i>
                </a>
              </li>
              <li class="page-item hoverActive">
                <a class="page-link" [class.my-class]="ptrDashboardSearchCriteria.pagenumber === 1" (click)="prev()">
                  <i class="fas fa-chevron-left"></i>
                </a>
              </li>
              <li class="page-item">
                <input type="number" style="margin: 2px 0.3rem;width: 30px;" value="{{ptrDashboardSearchCriteria.pagenumber}}" (input)="changePage($event.target.value)" />
              </li>
              <li class="page-item">
                <a class="page-link">/{{pageCount}}</a>
              </li>
              <li class="page-item hoverActive">
                <a class="page-link" [class.my-class]="ptrDashboardSearchCriteria.pagenumber === pageCount" (click)="next()">
                  <i class="fas fa-chevron-right"></i>
                </a>
              </li>
              <li class="page-item hoverActive">
                <a class="page-link" [class.my-class]="ptrDashboardSearchCriteria.pagenumber === pageCount" (click)="last()">
                  <i class="fas fa-angle-double-right"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>